export const invalidChars = [];
